import React from 'react';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import { withStyles } from '@material-ui/core/styles';
import stychLogo from '../../assets/images/stychLogo.png';
import { styles } from './styles';

class Footer extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <AppBar position='fixed' className={classes.footer}>
        <Toolbar variant='dense'>
          <Typography variant='caption' color='primary' mb={1} className={classes.stychPowered}>
            Powered by <img src={stychLogo} style={{ margin: '0 .5rem' }} alt='stychLogo' height='30px' />
            STYCH
          </Typography>
        </Toolbar>
      </AppBar>
    );
  }
}

export default withStyles(styles)(Footer);
